import {CreateOrUpdateRole} from 'api/gen/CreateOrUpdateRole';
import {roleCodeMaxLength, roleCodeMinLength} from 'api/gen/RoleCode';
import {roleNameMaxLength, roleNameMinLength} from 'api/gen/RoleName';
import {t} from 'app/translations';
import {EskotValidator} from 'utils/eskot-validator';
import {Errors} from 'utils/validator';

const te = t('admin');

/**
 * Validates role form values.
 *
 * @param values Role form state.
 * @returns Validation errors keyed by form field.
 */
export const validate =
    (values: CreateOrUpdateRole): Errors<CreateOrUpdateRole> => {
        const validator = new EskotValidator(values);

        validator.nonEmpty('code', te('code'));
        validator.maxStringLength('code', roleCodeMaxLength, te('code'));
        validator.minStringLength('code', roleCodeMinLength, te('code'));

        validator.nonEmpty('name', te('name'));
        validator.maxStringLength('name', roleNameMaxLength, te('name'));
        validator.minStringLength('name', roleNameMinLength, te('name'));

        validator.nonEmpty('discriminatorId', te('discriminator'));

        validator.nonEmpty('userEnable', te('userEnableRole'));

        return validator.generateErrorsObject();
    };
